/**
 * Rasterizes the SVG that recharts renders inside `container` into a base64 PNG (no data: prefix),
 * on a white background, at 2× scale. Returns undefined when there is no chart or the browser blocks canvas export.
 */
export const chartToPngBase64 = async (container: HTMLElement | null, scale = 2): Promise<string | undefined> => {
  const svg = container?.querySelector<SVGSVGElement>('svg.recharts-surface');
  if (!svg) return undefined;

  const { width, height } = svg.getBoundingClientRect();
  if (!width || !height) return undefined;

  const clone = svg.cloneNode(true) as SVGSVGElement;
  clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  clone.setAttribute('width', String(width));
  clone.setAttribute('height', String(height));
  const xml = new XMLSerializer().serializeToString(clone);
  const svgUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(xml)}`;

  const img = new Image();
  await new Promise<void>((resolve, reject) => {
    img.onload = () => resolve();
    img.onerror = () => reject(new Error('svg load failed'));
    img.src = svgUrl;
  });

  const canvas = document.createElement('canvas');
  canvas.width = Math.round(width * scale);
  canvas.height = Math.round(height * scale);
  const ctx = canvas.getContext('2d');
  if (!ctx) return undefined;
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.scale(scale, scale);
  ctx.drawImage(img, 0, 0, width, height);

  try {
    return canvas.toDataURL('image/png').split(',')[1];
  } catch {
    return undefined;
  }
};
